export default __webpack_public_path__ + "static/media/cleaning.297190d2.svg";